import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getBusinessPartnerStatus } from '../../../api/v2/businessPartner';
import { getNeeNorComplianceStatus, putNeeNor } from '../../../api/v2/neenor';

export const complianceQueryKeys = {
  businessPartnerStatus: (id) => ['v2', 'businessPartnerStatus', id],
  neeNorComplianceStatus: (id, incoterm = '') => ['v2', 'neeNorComplianceStatus', id, incoterm],
  neeNorDetails: (id) => ['v2', 'neeNorDetails', id],
  qaPreferences: (loadId) => ['qaPreferences', loadId],
};

export const useNeeNorComplianceStatus = (id, incoterm = '') =>
  useQuery({
    queryKey: complianceQueryKeys.neeNorComplianceStatus(id, incoterm),
    queryFn: () => getNeeNorComplianceStatus(id, incoterm),
    enabled: !!id,
  });

const useUpdateNeeNor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => putNeeNor(data),
    onSuccess: (_data, variables) => {
      if (variables?.id) {
        queryClient.invalidateQueries({ queryKey: complianceQueryKeys.neeNorDetails(variables.id) });
        queryClient.invalidateQueries({ queryKey: ['v2', 'neeNorComplianceStatus', variables.id] });
      }
    },
  });
};

/** Imperative helpers for flows that still need fetch-on-demand (kebab refresh, effects). */
export const useComplianceChecklistActions = () => {
  const queryClient = useQueryClient();
  const updateNeeNor = useUpdateNeeNor();

  const fetchBusinessPartnerStatus = (id) =>
    queryClient.fetchQuery({
      queryKey: complianceQueryKeys.businessPartnerStatus(id),
      queryFn: () => getBusinessPartnerStatus(id),
    });

  const fetchNeeNorComplianceStatus = (id, incoterm = '') =>
    queryClient.fetchQuery({
      queryKey: complianceQueryKeys.neeNorComplianceStatus(id, incoterm),
      queryFn: () => getNeeNorComplianceStatus(id, incoterm),
    });

  return {
    fetchBusinessPartnerStatus,
    fetchNeeNorComplianceStatus,
    updateNeeNor,
  };
};
